import {
  Grid,
  Backdrop,
  CircularProgress,
  LinearProgress,
  TextField,
  MenuItem,
  Container,
} from "@material-ui/core";

import { EgressMainTable } from "./egressTables/EgressMainTable";

import { ErrorMessage } from "../common/ErrorMessage";

import { useVerifyData } from "./dataEgressQueries";
import React from "react";
import { useLocations } from "../intake/intakeQueries";
import { useQuery, useQueryClient } from "react-query";
import { alignBox, boxAlignments } from "@nivo/core";

export const DataLandingPage = () => {

  const {
    error: errorLocations,
    data: locations,
    isLoading: isLoadingLocations,
    isError: isErrorLocations,
  } = useLocations();

  const useQuery = useQueryClient()

  const [location_id, setLocation] = React.useState(5);

  const handleChangeLocation = async (event: { target: { value: any; }; }) => {
    const selected_location_id = event.target.value;
    setLocation(selected_location_id);    
  };

  const {
    data,
    error,
    isLoading,
    isError,
    isFetching,
  } = useVerifyData(location_id);

  if (isLoading) {
    return (
      <Backdrop open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (isFetching) {
    return (

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={4}
      >


        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      </Grid>
    );
  }

  if (isError) {
    return <ErrorMessage error={error} />;
  }

  return (
   <>
  
    <Grid container justifyContent="flex-end" style={{marginRight:20}}>
    <TextField
            id="location"
            type="text"
            name="location"
            select={true}
            style={{  marginBottom: 20 , width:200,}}
            value={location_id}
            variant="outlined"
            onChange={handleChangeLocation}
            label="Location"
            data-testid="location"
          >
            {locations?.map((location: any) => (
              <MenuItem key={location.id} value={location.id}>
                {location.name}
              </MenuItem>
            ))}
          </TextField>
    </Grid>
    <EgressMainTable rowData={data} />
    </>
  );
};
